'use strict'

/*
 * This module does the following:
 * 1. it implements the retry and timeout resiliency patterns
 */
const axios = require('axios')
const axiosRetry = require('axios-retry')

axios.defaults.timeout = 10000

axiosRetry(axios, { retryDelay: axiosRetry.exponentialDelay })

module.exports = {
    axios,
    axiosRetry
}